import { render } from "./footer.vue?vue&type=template&id=79eb1f22&scoped=true&lang=html"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=79eb1f22&scoped=true&lang=scss"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\EngeeGit\\EngeeAPI\\AdminPanel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79eb1f22"]])

export default __exports__